import { DashboardComponent } from './../dashboard/dashboard.component';
import { SharedModule } from './../../shared/shared.module';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/core/guard/auth.guard';
import { SideNavComponent } from 'src/core/layouts/side-nav/side-nav.component';
import { SingleCardComponent } from 'src/core/layouts/single-card/single-card.component';
import { NotFoundComponent } from 'src/core/layouts/components/not-found/not-found.component';
import { NgModule } from '@angular/core';
import { StatistiquesComponent } from '../statistiques/statistiques.component';
import { StartupComponent } from 'src/core/layouts/components/startup/startup.component';

const routes: Routes = [
  { path: '*', redirectTo: 'startup', pathMatch: 'full' },
  {
    canActivate: [AuthGuard],
    path: '',
    component: SideNavComponent,
    children: [
      {
        path: '',
        redirectTo: 'startup',
        pathMatch: 'full'
      },
      {
        path: 'startup',
        component: StartupComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'citoyen',
        loadChildren: () =>
          import('../citoyen/citoyen.module').then(m => m.CitoyenModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'parcs',
        loadChildren: () =>
          import('../parcs/parcs.module').then(m => m.ParcsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'dechets',
        loadChildren: () =>
          import('../dechets/dechets.module').then(m => m.DechetsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'conteneurs',
        loadChildren: () =>
          import('../conteneurs/conteneurs.module').then(m => m.ConteneursModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'transport',
        loadChildren: () =>
          import('../transport/transport.module').then(m => m.TransporteurModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'evacuations',
        loadChildren: () =>
          import('../evacuations/evacuations.module').then(m => m.EvacuationsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'exutoires',
        loadChildren: () =>
          import('../exutoires/exutoires.module').then(m => m.ExutoiresModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'visiteurs',
        loadChildren: () =>
          import('../visiteurs/visiteurs.module').then(m => m.VisiteursModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'plaintes',
        loadChildren: () =>
          import('../plaintes/plaintes.module').then(m => m.PlaintesModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'documents',
        loadChildren: () =>
          import('../documents/documents.module').then(m => m.DocumentsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'visites',
        loadChildren: () =>
          import('../visites/visites.module').then(m => m.VisitesModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'utilisateurs',
        loadChildren: () =>
          import('../utilisateurs/utilisateurs.module').then(m => m.UtilisateursModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'entretien',
        loadChildren: () =>
          import('../entretien/entretien.module').then(m => m.EntretienModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'stock',
        loadChildren: () =>
          import('../stock/stock.module').then(m => m.StockModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'rapports',
        loadChildren: () =>
          import('../rapports/rapports.module').then(m => m.RapportsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'statistics',
        component: StatistiquesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'parametres',
        loadChildren: () =>
          import('../parametres/parametres.module').then(m => m.ParametresModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'pda',
        loadChildren: () =>
          import('../pda/pda.module').then(m => m.PdaModule),
        canActivate: [ AuthGuard ]
      },
    ]
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('../login/login.module').then(m => m.LoginModule),
    canActivate: [ AuthGuard ]
  },
  {
    path: '**',
    component: NotFoundComponent,
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  providers: [ AuthGuard ],
  exports: [RouterModule],
  schemas: [],
  declarations: [
  ]
})
export class AppRoutingModule { }
